module.exports = __webpack_public_path__ + "static/media/faq_mail.42c9f68d.svg";